import React, { useState, useEffect } from 'react'
import { useLanguage } from 'app/contexts/language'
import { Error } from 'app/shared/types'
import dictionaryService from 'services/http/dictionary'
import SplashScreen from 'components/splash-screen'
import { NodeEnv } from 'app/shared/enums'

const Capsule: React.FunctionComponent = ({ children }) => {
  const [error] = useState<Error>()
  const [isReady, setIsReady] = useState(false)
  const [languageContext, languageState] = useLanguage()

  useEffect(() => {
    if (process.env.NODE_ENV === NodeEnv.Development) {
      const error: Error = {
        code: 503,
        name: 'Service Unavailable',
        message:
          'The server cannot be reached. There could be many reasons for this.',
      }
    }
  }, [])

  useEffect(() => {
    const path = window.location.pathname
    const lang = path.replace('/', '').split('/')

    if (lang[0]) {
      languageContext.set(lang[0])
    }
  }, [languageContext])

  useEffect(() => {
    setIsReady(false)
    dictionaryService
      .get({ languageCode: languageState, pageSize: 100000 })
      .then((res) => {
        localStorage.setItem(
          'lang-dictionary',
          JSON.stringify(res.data.dataList)
        )
        setIsReady(true)
      })
      .catch((err: Error) => {})
  }, [languageState])

  if (isReady) {
    return (
      <React.Suspense fallback={<SplashScreen />}>{children}</React.Suspense>
    )
  }

  return <SplashScreen error={error} />
}

export default Capsule
